<template>
  <!-- Quotation(V)小额补款 - 单项 -->
  <div class="packageWrap">
    <el-table :data="tableData" class="wdb100" :header-cell-style="{ background: '#fdf6ec !important' }" :row-style="{ background: '#fdf6ec' }">
      <el-table-column prop="adjustmentNo" :label="$t('home.supplementalNo')" align="center" />
      <el-table-column prop="applymentNo" :label="$t('home.linkedTransactionNo')" align="center"></el-table-column>
      <el-table-column prop="billingParty" :label="$t('home.billingParty')" align="center"></el-table-column>
      <el-table-column :label="$t('home.serviceCharge')" align="center">
        <template slot-scope="scope">
          <p class="fwb">{{ priceCurrencyFormat(scope.row.serviceChargeTotal, billingCurrency) }}</p>
        </template>
      </el-table-column>
      <el-table-column :label="$t('home.thirdPartyFee')" align="center">
        <template slot-scope="scope">
          <p class="fwb">{{ priceCurrencyFormat(scope.row.thirdPartyFeeTotal, billingCurrency) }}</p>
        </template>
      </el-table-column>
      <el-table-column :label="$t('home.otherFee')" align="center">
        <template slot-scope="scope">
          <p class="fwb">{{ priceCurrencyFormat(scope.row.otherFeeTotal, billingCurrency) }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="applyReason" :label="$t('home.description')" align="center"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { isNumberLike } from "@/utils/common";
import { addition } from "@/utils/count";
import formatMixin from "@/mixins/formatMixin";
import { mapGetters } from "vuex";
export default {
  mixins: [formatMixin],
  props: {
    adjustment: {
      type: Object,
      default: () => {},
    },
    billingCurrency: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
    tableData() {
      if (!this.adjustment) return [];
      // 初始化三类费用的总和
      let serviceCharge = 0; // category: 1
      let thirdPartyFee = 0; // category: 2
      let otherFee = 0; // category: 3
      // 遍历 itemList 进行分类累加
      this.adjustment?.itemList?.forEach(item => {
        const amount = isNumberLike(item.billingAmount) ? item.billingAmount : 0;
        if (item.category === 1) {
          serviceCharge = addition(serviceCharge, amount);
        } else if (item.category === 2) {
          thirdPartyFee = addition(thirdPartyFee, amount);
        } else if (item.category === 3) {
          otherFee = addition(otherFee, amount);
        }
      });

      return [
        {
          ...this.adjustment,
          serviceChargeTotal: serviceCharge,
          thirdPartyFeeTotal: thirdPartyFee,
          otherFeeTotal: otherFee,
        },
      ];
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.packageWrap {
  width: 100%;
  background-color: #fdf6ec;

  ::v-deep {
    .el-table {
      tr:hover {
        background: #fdf6ec !important;
      }

      .el-table__body tr:hover > td {
        background-color: #fdf6ec !important;
      }
    }
  }
}
</style>
